import React, { useState } from 'react';
import commitmentService from '~/services/commitmentService';
import {
  ModalOverlay,
  ModalContainer,
  Header,
  CloseButton,
  BackButton,
  Content,
  HeaderTitle,
  ModalTitle,
  ModalSubtitle,
  RatingSection,
  SectionTitle,
  StarsContainer,
  StarIcon,
  Separator,
  CommentsSection,
  CommentsTitle,
  CommentsContainer,
  TextArea,
  CharacterCount,
  Footer,
  FooterButton,
  ValidationMessageError,
  ValidationMessageInfo,
  LoadingOverlay
} from './styles';
import ResponseRegisteredModal from '../ResponseRegisteredModal';
import Loading from '../layout/Loading';
import StartBlueIcon from '../../assets/images/star_blue.svg';
import ArrowIcon from '../../assets/images/arrow.svg';

const ConsultantRatingModal = ({ isOpen, onClose, onBack, onNext, onPatchRating, onCloseWithoutApi }) => {
  const [visitRating, setVisitRating] = useState(0);
  const [commentsText, setCommentsText] = useState('');
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleStarClick = (rating) => {
    setVisitRating(rating);
  };

  const handleBack = () => {
    setVisitRating(0);
    setCommentsText('');
    if (typeof onBack === 'function') {
      onBack();
    }
  };

  const handleNext = async () => {
    if (visitRating > 0) {
      setIsSubmitting(true);
      const data = {
        comment: (commentsText || '').trim(),
        visit_rating: visitRating,
      };
      try {
        const body = {
          inviteId: '',
          name: localStorage.getItem('userName') || '',
          email: localStorage.getItem('email') || '',
          phone: localStorage.getItem('consultantPhone') || '',
          review: visitRating,
          feedback: (commentsText || '').trim() || undefined,
          additionalQuestions: [],
          indicators: [
            {
              column: "Nome da revenda",
              value: localStorage.getItem('storeName') || ''
            },
            {
              column: "Código de Cliente",
              value: localStorage.getItem('storeId') || ''
            },
            {
              column: "Código de Endereço",
              value: localStorage.getItem('addressId') || ''
            },
            {
              column: "Mercado",
              value: localStorage.getItem('market') || ''
            },
            {
              column: "Núcleo",
              value: localStorage.getItem('core') || ''
            },
            {
              column: "Estado",
              value: localStorage.getItem('state') || ''
            },
            {
              column: "UF",
              value: localStorage.getItem('userUf') || ''
            }
          ],
        };

        await commitmentService.postIndecxAnswer(body);
        data.indecxPatched = true;
      } catch (err) {
        console.warn('Indecx answer PATCH failed', err);
      }

      if (typeof onPatchRating === 'function') {
        try {
          const patchPayload = {
            visit_rating: data.visit_rating,
            user_id: localStorage.getItem('userId') || null,
            comment_rating: data.comment || ''
          };

          await onPatchRating(patchPayload);
          data.patched = true;
        } catch (e) {
          console.warn('onPatchRating error', e);
        }
      }

      if (onNext) {
        try {
          onNext(data);
        } catch (e) {
          console.warn('ConsultantRatingModal onNext error', e);
        }
      }

      setIsSubmitting(false);
      setShowResponseModal(true);
    }
  };

  const handleResponseModalClose = () => {
    setShowResponseModal(false);
    onClose();
  };

  const canProceed = visitRating > 0 && (visitRating > 2 || commentsText.trim().length >= 10);

  return (
    <>
      {!showResponseModal && (
        <ModalOverlay>
          <ModalContainer onClick={(e) => e.stopPropagation()}>
            <Header>
              <BackButton onClick={handleBack}>
                <img src={ArrowIcon} alt="Voltar" />
                <span>Voltar</span>
              </BackButton>
              <CloseButton onClick={() => { if (typeof onClose === 'function') onClose(); }}>×</CloseButton>
            </Header>

        <Content>

            <img src={StartBlueIcon} alt="Avaliação" />


          <HeaderTitle>
            <ModalTitle>Sua avaliação</ModalTitle>
            <ModalSubtitle>
              Sua opinião nos ajuda a melhorar a experiência com nossas visitas.
            </ModalSubtitle>
          </HeaderTitle>

          <RatingSection>
            <SectionTitle>
              O que achou da visita?
              <br />
              Escolha entre 1 a 5 estrelas para classificar
              <br />
              (5 para muito satisfeito e 1 para pouco satisfeito)
            </SectionTitle>
            <StarsContainer>
              {[1, 2, 3, 4, 5].map((star) => (
                <StarIcon
                  key={star}
                  filled={star <= visitRating}
                  onClick={() => handleStarClick(star)}
                >
                  ★
                </StarIcon>
              ))}
            </StarsContainer>

            <CommentsSection>
              <CommentsTitle>
                Escreva um comentário {visitRating <= 2 ? '(obrigatório)' : '(opcional)'}
              </CommentsTitle>
              <CommentsContainer>
                <TextArea
                  value={commentsText}
                  onChange={(e) => setCommentsText(e.target.value)}
                  onMouseDown={(e) => e.stopPropagation()}
                  onTouchStart={(e) => e.stopPropagation()}
                  placeholder="Conte-nos o que aconteceu"
                  maxLength={250}
                />
                <CharacterCount>{commentsText.length}/250</CharacterCount>
              </CommentsContainer>
              {visitRating <= 2 && commentsText.length > 0 && commentsText.length < 10 && (
                <ValidationMessageError>
                  Mínimo de 10 caracteres para enviar ({commentsText.length}/10)
                </ValidationMessageError>
              )}

              {visitRating <= 2 && commentsText.length === 0 && (
                <ValidationMessageInfo>
                  Mínimo de 10 caracteres para enviar
                </ValidationMessageInfo>
              )}
            </CommentsSection>
          </RatingSection>

          <Separator />

        </Content>

            <Footer>
              <FooterButton
                primary
                disabled={!canProceed}
                onClick={handleNext}
              >
                Enviar
              </FooterButton>
            </Footer>
          </ModalContainer>
        </ModalOverlay>
      )}

      {isSubmitting && (
        <LoadingOverlay>
          <Loading />
        </LoadingOverlay>
      )}

      <ResponseRegisteredModal
        isOpen={showResponseModal}
        onClose={handleResponseModalClose}
      />
    </>
  );
};

export default ConsultantRatingModal;
